
export default {
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    show: {
      type: Boolean,
      default: false
    },
    num: {
      type: Number,
      default: 0
    }
  }
}
